import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import zhCN from 'ant-design-vue/es/locale/zh_CN';
// import ZoomTip from '@/components/common/ZoomTip.vue';
import 'dayjs/locale/zh-cn';
import { service as globalService } from '@/modules/global';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const getPopupContainer = (node: any) => {
  if (node) {
    return node.parentNode;
  }
  return document.body;
};

window.addEventListener('resize', () => {
  globalService.checkIsMobile();
});
setTimeout(() => {
  globalService.checkIsMobile();
}, 100);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, {
    locale: _unref(zhCN),
    "get-popup-container": getPopupContainer
  }, {
    default: _withCtx(() => [
      _createVNode(_component_router_view)
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})